var map = {
	"./icon-1.svg": "TwjN",
	"./icon-10.svg": "C5oE",
	"./icon-11.svg": "Vf1Q",
	"./icon-12.svg": "2TJe",
	"./icon-13.svg": "/M7o",
	"./icon-14.svg": "xfOV",
	"./icon-15.svg": "DCzD",
	"./icon-16.svg": "Zwdm",
	"./icon-2.svg": "Zs2p",
	"./icon-3.svg": "Y364",
	"./icon-4.svg": "Wmtv",
	"./icon-5.svg": "VWOf",
	"./icon-6.svg": "V70H",
	"./icon-7.svg": "Cb69",
	"./icon-8.svg": "oY43",
	"./icon-9.svg": "ZDrJ"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IbP3";